import React, { Component } from "react";
import _ from 'lodash';
import {Table, Pagination, FormControl, InputGroup, Button, Dropdown, DropdownButton, Row, Col} from 'react-bootstrap'
import EditModalWindow from './EditModalWindow';
import ViewWebForm from './ViewWebForm';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS

function searchingFor(term, eventKey, subKey){ 
	return function(x){        
    let a = x[eventKey];
    if(_.isArray(x[eventKey])){
      let gg =[]
      _.map(a, (obj) =>{
        gg.push(_.includes(obj[subKey].toLowerCase(), term.toLowerCase()))
      })
      return _.includes(gg, true) || !term
    } else {
      if(subKey !== null){        
        return _.includes(a[subKey].toLowerCase(), term.toLowerCase()) || !term;
      } else {
        return _.includes(x[eventKey].toLowerCase(), term.toLowerCase()) || !term;
      }
    }
	}
}
export default class FormList extends Component {
  constructor(props){
    super(props)
    this.state={
      activePage:1,
      term:'',
      eventKey:'form',
      subKey:'title',
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[]
   }
   this.bulkclientName = []
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
    activePage: eventKey,
    });
  }
  handleSelectPaginationPrev = () => {
    const {activePage} = this.state;
    this.setState({
    activePage: activePage-1,
    });
  }
  handleSelectPaginationNext = () => {
    const {activePage} = this.state;
    this.setState({
    activePage: activePage+1,
    });
  }	
  editMe = (prop, index) => {
    this.setState({[prop + index]:true})
  }
  editMeClose = (prop, index) => {
    this.setState({[prop + index]:false})
  }
  openModalView =(index) => {
		this.setState({['modalIsRead'+index]: true, });
	}
	
	closeModalView=(index) =>{
		this.setState({['modalIsRead'+index]: false, });
  }
  handleChange = (e) => {
		this.setState({term:e.target.value})	
  }
  searchFilter =(e, sub) =>{
    this.setState({eventKey:e, subKey:sub})
    if(!_.isEqual(this.state.eventKey, e)){
      this.setState({term:''})
    }
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () => {
    const{selectedcenterName} = this.state
    let clientNames =[]
    if(!_.isEmpty(selectedcenterName)){    
      _.map(selectedcenterName, (obj) =>{ 
        let x = _.filter(obj.userClients);
        clientNames.push(...x );
        this.bulkclientName=clientNames 
      })
      return  _.uniqBy(clientNames, 'inventoryClientId')
    } 
  }
  processNames = () => {
    const{selectedclientName} = this.state
    let processNames = []
    if(!_.isEmpty(selectedclientName)){     
        _.map(selectedclientName, (obj) =>{
            let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
          _.map(abc, (z) => {
            processNames.push(...z.userProcesses)
            processNames = _.uniqBy(processNames, 'inventoryProcessId');
          }) 
        })
        return processNames
    } 
  }
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], viewForm:false})
      
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      
      this.setState({selectedclientName:[], selectedprocessName:[], viewForm:false})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      
      this.setState({selectedprocessName:[], viewForm:false})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});  
   if(!_.isEqual(this.state.selectedprocessName, e)){
      this.setState({viewForm:false})
    }
  } 
  handleWebForm =  () =>{
    this.setState({viewForm:true})
    let data = {
      'region':{'id':this.state.selectedregionName.inventoryRegionId, 'label':this.state.selectedregionName.inventoryRegionName}, 
      'center':_.map(this.state.selectedcenterName, (obj) => {
        return {'id':obj.inventoryCenterId, 'label':obj.inventoryCenterName}
      }),
      'client':_.map(this.state.selectedclientName, (obj) => {
        return({'id':obj.inventoryClientId, 'label':obj.inventoryClientName})
      }),
      'process':_.map(this.state.selectedprocessName, (obj) => {
        return({'id':obj.inventoryProcessId, 'label':obj.inventoryProcessName})
      }),
    }
    this.props.action.TokenValidation()  
    this.props.action.mappedFormList(data)
  }

  render(){
    const{mappedTemplate, accessPermission} = this.props;     		  
    let permission  = _.includes(accessPermission, 'WRITE') 
    const{activePage, term, eventKey, subKey, viewForm, selectedregionName, selectedcenterName, selectedclientName, selectedprocessName} = this.state;
    const Per_Page=50;    
    const startOffset = (this.state.activePage-1) * Per_Page;
    let startCount = 0;
    let items = [];
    let totalPages = 1
    if(!_.isEmpty(mappedTemplate)){
     totalPages = Math.ceil(mappedTemplate.length/Per_Page)
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
          {number}
        </Pagination.Item>				
      );
      }
    }
    let mapRequest={}
    if(!_.isEmpty(selectedregionName) && !_.isEmpty(selectedcenterName) && !_.isEmpty(selectedclientName) && !_.isEmpty(selectedprocessName)){
      mapRequest = {
        'region':{'id':this.state.selectedregionName.inventoryRegionId, 'label':this.state.selectedregionName.inventoryRegionName}, 
        'center':_.map(this.state.selectedcenterName, (obj) => {
          return {'id':obj.inventoryCenterId, 'label':obj.inventoryCenterName}
        }),
        'client':_.map(this.state.selectedclientName, (obj) => {
          return({'id':obj.inventoryClientId, 'label':obj.inventoryClientName})
        }),
        'process':_.map(this.state.selectedprocessName, (obj) => {
          return({'id':obj.inventoryProcessId, 'label':obj.inventoryProcessName})
        }),
      }
    }
    return(<div>
        <Row className='marginBottom'>
         <Col><label><b>REGION NAME<span className="RedColoring"> *</span></b></label><br/>
          <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={false}
          placeholder='Select Region'
          dropdownHeight={600}
          /></Col>
          <Col><label><b>CENTER NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={true}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Center'
          dropdownHeight={600}
          /></Col>
          <Col><label><b>CLIENT NAME<span className="RedColoring"> *</span></b></label>
          <Picky keepOpen={false}
          value={this.state.selectedclientName}
          options={this.clientNames()}
          onChange={this.handleSelectClient}
          open={false}
          valueKey="inventoryClientName"
          labelKey="inventoryClientName"
          multiple={true}
          includeSelectAll={true}
          includeFilter={false}
          placeholder='Select Client'
          dropdownHeight={600}
          /></Col>
          <Col><label><b>PROCESS NAME<span className="RedColoring"> *</span></b></label>
            <Picky keepOpen={false}
            value={this.state.selectedprocessName}
            options={this.processNames()}
            onChange={this.handleSelectProcess}
            open={false}
            valueKey="inventoryProcessName"
            labelKey="inventoryProcessName"
            multiple={true}
            includeSelectAll={true}
            includeFilter={false}
            placeholder='Select Process'
            dropdownHeight={600}
          /></Col>
          <Col><Button style={{marginTop:'25px'}} onClick={this.handleWebForm}>View Mapped Web Form</Button></Col>        
        </Row>     
        {viewForm === true ?
        <div>
        <span className='alignRight'>
				<InputGroup>
					<InputGroup.Prepend>
						<InputGroup.Text id="basic-addon1"><i class="fas fa-search"></i></InputGroup.Text>
					</InputGroup.Prepend>
					<FormControl
						placeholder="Search"
						aria-label="Search"
						aria-describedby="basic-addon1"
						onChange={(e) => this.handleChange(e)}
						value={term}
						/>
            <DropdownButton
						 as={InputGroup.Append}
             alignRight
             variant="outline-secondary"
             title=""           
             id="dropdown-menu-align-right"
						>           
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'title')} eventKey="form" active={eventKey === "form"}  ><b>FORM NAME</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'label')} eventKey="process" active={eventKey === "process"}  ><b>PROCESS</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'label')} eventKey="client" active={eventKey === "client"}  ><b>CLIENT</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'label')} eventKey="center" active={eventKey === "center"}  ><b>CENTER</b></Dropdown.Item>
            <Dropdown.Item 	onSelect={(eventKey) =>this.searchFilter(eventKey, 'label')} eventKey="region" active={eventKey === "region"}  ><b>REGION</b></Dropdown.Item>
            </DropdownButton>
				</InputGroup>
			 </span>
       <Table responsive>
        <thead>
          <th>REGION</th>
          <th>CENTER</th>
          <th>CLIENT</th>
          <th>PROCESS</th>
          <th>FORMS</th>
          {(permission === true) ? <th>ACTIONS</th> : null}
        </thead>
        <tbody>
        {!_.isEmpty(mappedTemplate) ?        
        _.map(mappedTemplate.filter(searchingFor(term, eventKey, subKey)), (obj, index)=>{
              if(index >= startOffset & startCount < Per_Page){
              startCount++;
              let region = obj.region.label;
              let center = obj.center.label;
              let clients = obj.client.label;
              let process = obj.process.label;
              let Regiontitle = region+" / "+center+" / "+clients+" / "+process
            return(
            <tr>
              <td>{obj.region.label}</td>
              <td>{obj.center.label}</td>
              <td>{obj.client.label}</td>
              <td>{obj.process.label}</td>
              <td>{obj.form.title}</td>
              <td>    
              {(permission === true) ? <span>
              {/* <i class='fas fa-pen' onClick={()=>this.editMe('edit', index)}/>
               {this.state['edit'+index] ? 
                <EditModalWindow closeModal={()=>this.editMeClose('edit', index)} action={this.props.action}  loginAction={this.props.loginAction}
                  form={obj.form}/>             
                : null}  */}
              <i class="fas fa-link" onClick={()=>this.editMe('link', index)} />
               {this.state['link'+index] ? 
                <EditModalWindow link={true} closeModal={()=>this.editMeClose('link', index)}
                  action={this.props.action} webFormNames={this.props.webFormNames}
                  mapRequest={mapRequest}
                  form={obj}/>             
                : null}</span> : null}            
              <i class='fas fa-eye' onClick={()=>this.openModalView(index)}/>
              {this.state['modalIsRead'+index] ?
              <ViewWebForm closeModal={()=>this.closeModalView(index)}Regiontitle={Regiontitle}  data={obj.form}/> : null}
						</td> 
            </tr>)
          }
          })  :
        <tr><td colSpan={(permission === true) ? "6" : "7"}>No Record Found</td></tr>

        }
        </tbody>
        </Table>
      {!_.isEmpty(items) ?
      <Pagination>
      <Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
      <Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
        {items[activePage-1]}
        {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
        {items[activePage+1]}
      <Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
      <Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
      </Pagination> : null}
      </div> : null}

      </div>)
  }
}